import { ChangeEvent, MouseEvent, useState } from 'react';
import { IFitoListItem } from '~/Components';
import { useDragAndDropComponent } from '~/Hooks';
interface IUseFitoListItemProps {
  item: IFitoListItem;
  index: number;
  listName?: string;
  moveItem?: (id: string, hoverIndex: number) => void;
  findItemIndex?: (id: string) => number;
  onSelect?: (id: string, checked?: boolean) => void;
  setChecked?: (checked: boolean) => void;
}
export const useFitoListItem = ({
  item,
  listName,
  index,
  moveItem,
  findItemIndex,
  onSelect,
  setChecked,
}: IUseFitoListItemProps) => {
  const { drag, drop, handlerId } = useDragAndDropComponent(
    listName || 'defaultListName',
    index,
    item.id,
    moveItem,
    findItemIndex,
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleMenuOpen = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onCheckboxChecked = (e: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    e.stopPropagation();
    setChecked?.(checked);
    onSelect?.(item.id, checked);
  };

  return { drag, drop, handlerId, anchorEl, handleMenuOpen, handleClose, onCheckboxChecked };
};
